import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { CountyWithMunicipalities } from 'src/features/one-way-in/hooks/use-geonorge';

export type CountyWithSelectedMunicipalityCount = CountyWithMunicipalities & {
  selectedMunicipalityCount: number;
};

const columnHelper = createColumnHelper<CountyWithSelectedMunicipalityCount>();

// Compare selected count, selection rate, fewer total municipalities, then Norwegian county name; TanStack reverses all criteria for descending order.
const compareCountySelectionRanking = (
  rowA: CountyWithSelectedMunicipalityCount,
  rowB: CountyWithSelectedMunicipalityCount,
) => {
  const selectedCountDifference = rowA.selectedMunicipalityCount - rowB.selectedMunicipalityCount;
  if (selectedCountDifference !== 0) {
    return selectedCountDifference;
  }

  const selectionRateDifference =
    rowA.selectedMunicipalityCount / rowA.kommuner.length -
    rowB.selectedMunicipalityCount / rowB.kommuner.length;
  if (selectionRateDifference !== 0) {
    return selectionRateDifference;
  }

  const totalMunicipalityCountDifference = rowB.kommuner.length - rowA.kommuner.length;
  if (totalMunicipalityCountDifference !== 0) {
    return totalMunicipalityCountDifference;
  }

  return rowA.fylkesnavn.localeCompare(rowB.fylkesnavn, 'nb-NO');
};

export const countyColumns = [
  columnHelper.accessor((row) => row.fylkesnavn, {
    id: 'Fylke',
    minSize: 120,
    size: 120,
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor((row) => row.fylkesnummer, {
    id: 'Fylkesnummer',
    minSize: 50,
    size: 50,
    maxSize: 50,
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor((row) => row.selectedMunicipalityCount, {
    id: 'Antall kommuner valgt',
    minSize: 220,
    size: 220,
    sortDescFirst: true,
    sortingFn: (rowA, rowB) => compareCountySelectionRanking(rowA.original, rowB.original),
    cell: (info) => {
      return <span>{`${info.getValue()}/${info.row.original.kommuner.length}`}</span>;
    },
  }),
];
